<template>
  <div v-if="closingTime">
    <md-dialog :md-click-outside-to-close="false" id="createNewClosingTimeDialog" :md-active.sync="showDialog" @md-closed="closeDialog">

      <md-dialog-title>

        <form novalidate @submit.prevent="validateClosingTime">

          <div class="grid-x grid-padding-x">
            <div v-if="mode === 'update'" class="cell large-5 medium-5">
              <i class="fi-pencil"></i>&nbsp;&nbsp;&nbsp;Schließzeit bearbeiten
            </div>
            <div v-else-if="mode === 'add'" class="cell large-5 medium-5">
              <md-icon style="color: black; font-size: 16px!important; height: 14px;">timelapse</md-icon>&nbsp;&nbsp;&nbsp;Neue Schließzeit hinzufügen
            </div>
            <div class="cell large-2 medium-2" style="margin-top: -5px;">
              <SessionTime></SessionTime>
            </div>
            <div class="cell large-5 medium-5 text-center">
              <button v-if="mode === 'update'" class="button success" type="submit" :disabled="sending">
                <i class="fi-save"></i>&nbsp;&nbsp;&nbsp;Änderungen speichern
              </button>
              <button v-else-if="mode === 'add'" class="button success" type="submit" :disabled="sending">
                <md-icon style="color: black; font-size: 16px!important; height: 14px;">timelapse</md-icon>&nbsp;&nbsp;Hinzufügen
              </button>
              <button class="button alert" style="margin-left: 1rem;" @click="closeDialog" type="button"
                      :disabled="sending">
                <i class="fi-x"></i>&nbsp;&nbsp;&nbsp;Abbrechen
              </button>
            </div>
          </div>

        </form>

      </md-dialog-title>

      <md-dialog-content id="dialogContentId">
        <ClosingTimeForm v-if="closingTime" ref="closingTimeForm" :selectedYear="selectedYear"
                         :closingTime="closingTime" :sending="sending" :mode="mode">
        </ClosingTimeForm>

        <md-progress-bar md-mode="indeterminate" v-if="sending"/>

      </md-dialog-content>

      <button class="close-button" type="button" @click="closeDialog">
        <span aria-hidden="true">&times;</span>
      </button>
    </md-dialog>

    <md-dialog :md-click-outside-to-close="false" :md-active.sync="confirmMissingClosingTimeDataDialog">
      <div class="grid-x grid-padding-x grid-padding-y">
        <md-dialog-title>
          <md-icon style="color: black; font-size: 16px!important; height: 14px;">timelapse</md-icon>&nbsp;&nbsp;&nbsp;Unvollständigen
          Datensatz für Schließzeit bestätigen
        </md-dialog-title>
        <div class="cell">
          <md-content>Soll der unvollständige Datensatz wirklich gespeichert werden?
          </md-content>
          <br>
          <md-progress-bar md-mode="indeterminate" v-if="sending"/>
        </div>
        <div class="cell text-center">
          <div @click="confirmProcessingData" class="button success"><i class="fi-save"></i>&nbsp;&nbsp;&nbsp;Ja,
            speichern
          </div>
          <button class="button alert" style="margin-left: 1rem;"
                  @click="closeConfirmationDialog"
                  type="button"
                  :disabled="sending">
            <i class="fi-x"></i>&nbsp;&nbsp;&nbsp;Nein, lieber nicht
          </button>
        </div>
        <button class="close-button" type="button" @click="closeConfirmationDialog">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </md-dialog>
  </div>
</template>

<script>

  import jQuery from 'jquery';
  import HttpErrorHandler from '../../services/HttpErrorHandler'
  import FacilityService from "../../services/FacilityService";
  import ClosingTimeForm from '../forms/ClosingTimeForm';
  import Spinner from 'vue-simple-spinner'
  import SessionTime from '../animations/SessionTime';

  export default {
    name: 'EditClosingTimeDialog',

    components: {
      ClosingTimeForm,
      'vue-simple-spinner': Spinner,
      SessionTime,
    },

    props: {
      closingTime: {
        required: true
      },
      selectedYear: {
        required: true
      },
      facilityReferenceNumber: {
        required: true
      },
      showDialog: {
        required: true
      },
      mode: {
        required: true
      }
    },

    data: () => ({
      success: true,
      sending: false,
      confirmMissingClosingTimeDataDialog: false,
    }),

    methods: {

      addClosingTime() {
        this.sending = true;
        this.success = false;
        FacilityService.addClosingTime(this.facilityReferenceNumber, this.selectedYear, this.closingTime)
          .then(response => {
            this.success = true;
            this.sending = false;
            this.$emit("closeEditClosingTimeDialog");
            this.$emit("addClosingTimeSuccess", this.closingTime, response.data);
          })
          .catch(e => {
            HttpErrorHandler.handleError(e, this, 'Fehler beim Hinzufügen der Schließzeit ' + this.closingTime.name + ' für Einrichtung mit Ref-Nummer ' + this.facilityReferenceNumber);
            this.sending = false;
          })
      },

      confirmMissingData() {
        jQuery('#createNewClosingTimeDialog').attr("style", "display:none");
        this.confirmMissingClosingTimeDataDialog = true;
      },

      closeConfirmationDialog() {
        this.confirmMissingClosingTimeDataDialog = false;
        jQuery('#createNewClosingTimeDialog').attr("style", "display:normal");
      },

      confirmProcessingData() {
        this.closeConfirmationDialog();
        if (this.mode === 'update') {
          this.updateClosingTime();
        }
        if (this.mode === 'add') {
          this.addClosingTime();
        }
      },

      validateClosingTime() {

        this.$refs.closingTimeForm.validateClosingTime();

        if (!this.$refs.closingTimeForm.invalid) {
          if (this.mode === 'add') {
            this.addClosingTime();
          }
        }
      },

      closeDialog() {
        this.$emit("closeEditClosingTimeDialog");
      }
    },

    computed: {

      isAuthenticated() {
        return this.$store.getters.authenticated
      },

      isAdmin() {
        return this.$store.getters.admin
      },

      isSage() {
        return this.$store.getters.sage
      },

      organization() {
        return this.$store.getters.organization
      },

      labels() {
        return this.$store.getters.labels
      },
    },
  };
</script>

<style scoped>
  .md-dialog /deep/.md-dialog-container {
    max-width: 1000px;
  }

  h5 {
    font-weight: 400;
    color: lightseagreen;
  }
</style>
